/* eslint-disable */
import React, { useEffect, useState } from "react";
import Routes from "./routes";
import ThemeCustomization from "./themes";
import "./App.css";
import ScrollTop from "./components/ScrollTop";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { findDashboardByPermission } from "./utils/authorities";
import { activeItem } from "./store/reducers/menu";
import { logoutCredentials } from "./store/reducers/login-data";
import { useIdleTimer } from "react-idle-timer";
import UserActiveModal from "./components/custom-modal/UserActiveModal";
import SocketManager from "./utils/socketManager";


const TIMEOUT = 5 * 60 * 1000; // 300,000 ms - 5 minutes inactivity timeout
const PROMPT_BEFORE_IDLE = 19 * 1000;
const REMAINING_TIMER = 18;

function App() {
  const jwtToken = localStorage.getItem("user");

  const { loginId: loginID, permissions } = useSelector(
    (state) => state.loginData
  );

  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const location = useLocation();
  const navigate = useNavigate();
  const firstSegment = location.pathname.split("/")[1];

  // Idle Timer
  const [remaining, setRemaining] = useState(REMAINING_TIMER);
  const [open, setOpen] = useState(false);

  const onIdle = () => {
    setOpen(false);
    dispatch(logoutCredentials());
    localStorage.clear();
    navigate("/login");
  };

  const onActive = () => {
    setOpen(false);
  };

  const onPrompt = () => {
    if (
      !["/", "/login", "/forgot-password"].includes(pathname)
    ) {
      setOpen(true);
    }
  };

  const { getRemainingTime, activate } = useIdleTimer({
    onIdle,
    onActive,
    onPrompt,
    timeout: TIMEOUT,
    promptBeforeIdle: PROMPT_BEFORE_IDLE,
    throttle: 1000,
  });

  useEffect(() => {
    if (open) {
      const interval = setInterval(() => {
        setRemaining(Math.ceil(getRemainingTime() / 1000));
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [open]);

  const handleStillHere = () => {
    setRemaining(REMAINING_TIMER);
    activate();
  };

  // Dashboard redirection
  useEffect(() => {
    if (
      loginID &&
      jwtToken &&
      ["/", "/login", "/forgot-password"].includes(pathname)
    ) {
      const dashboardItems = findDashboardByPermission(permissions);
      const isChildExist = dashboardItems.length > 0
        ? dashboardItems[0]?.children?.[0]
        : null;

      dispatch(
        activeItem({
          openItem: isChildExist
            ? [isChildExist.parentId, firstSegment]
            : [firstSegment],
        })
      );

      const url = dashboardItems[0]?.url;
      if (url) {
        navigate(url);
      }
    }
  }, [pathname, permissions]);

  return (
    <ThemeCustomization>
      <ScrollTop>
        <Routes />
        <SocketManager /> 
        {open && (
          <UserActiveModal
            open={open}
            setOpen={setOpen}
            timer={remaining}
            handleStillThere={handleStillHere}
          />
        )}
      </ScrollTop>
    </ThemeCustomization>
  );
}

export default App;
